@if ( isCustomTranslationsEnabled !== null && isTaxRelatedCustomTranslationsEnabled !== null && showDynamicDateFormat
!== null && showSplitDelivery !== null && showOrderTypes !== null && order ) {
<div class="container-group">
  <div class="summary-title">
    <h2>{{ 'myAccount.orderDetails.orderSummary.title' | cxTranslate }}</h2>
  </div>
  <div class="summary-details">
    @if (!features?.hideOrderStatus) {
    <div class="group-info">
      <div class="label">{{ 'myAccount.orderDetails.orderSummary.orderStatus' | cxTranslate }}</div>
      <div class="value status-icon">
        <mat-icon [svgIcon]="getStatusIcon(order?.statusCode)"></mat-icon>
        {{ order?.statusDisplay }}
      </div>
    </div>
    }
    <div class="group-info">
      @if (isCustomTranslationsEnabled !== null) {
      <div class="label">
        {{
          'myAccount.orderDetails.orderSummary.orderNumber'
            | cxTranslate
              : {
                  context: setCustomContext(
                    isCustomTranslationsEnabled,
                    activeCountry$ | async,
                    activeLanguage$ | async
                  )
                }
        }}
      </div>
      }
      <div class="value">{{ order?.erpOrderNumber }}</div>
    </div>
    <div class="group-info">
      <div class="label">{{ 'myAccount.orderDetails.orderSummary.orderPoNumber' | cxTranslate }}</div>
      <div class="value">{{ order?.purchaseOrderNumber }}</div>
    </div>
    <div class="group-info">
      <div class="label">{{ 'myAccount.orderDetails.orderSummary.orderDate' | cxTranslate }}</div>
      @if (showDynamicDateFormat !== null) {
      <div class="value date">
        {{ order?.createdDateString | date : (showDynamicDateFormat ? (dateFormat$ | async) : 'dd/MM/yy; h:mma') }}
      </div>
      }
    </div>
    @if (!this.features.hideOrderBySplitDeliveryField) {
    <div class="group-info">
      <div class="label">{{ 'myAccount.orderDetails.orderSummary.orderBy' | cxTranslate }}</div>
      <app-tooltip-text
        class="value has-tooltip order-details-tooltip"
        [tooltipContent]="order?.placedBy"
        [content]="order?.placedBy"
        placement="bottom"
      ></app-tooltip-text>
    </div>
    } @if (showOrderTypes) {
    <div class="group-info">
      <div class="label">{{ 'orders.orderType' | cxTranslate }}</div>
      <div class="value">{{ order?.orderType }}</div>
    </div>
    } @if (!this.features.hideOrderBySplitDeliveryField && showSplitDelivery) {
    <div class="group-info">
      <div class="label">{{ 'myAccount.orderDetails.orderSummary.splitDelivery' | cxTranslate }}</div>
      <div class="value">
        {{
          !order?.deliverFullOrder
            ? ('myAccount.orderDetails.orderSummary.splitDeliveryTrue' | cxTranslate)
            : ('myAccount.orderDetails.orderSummary.splitDeliveryFalse' | cxTranslate)
        }}
      </div>
    </div>
    } @if (features.showHoldStatus) {
    <div class="group-info">
      <div class="label">{{ 'orders.holdStatus' | cxTranslate }}</div>
      <app-tooltip-text
        class="value has-tooltip order-details-tooltip"
        [tooltipContent]="order?.holdCode"
        [content]="order?.holdCode"
        placement="bottom"
      ></app-tooltip-text>
    </div>
    }
  </div>
</div>
<hr class="line-summary" />
<div class="container-group summary-total">
  <div class="summary-details">
    <div class="group-info">
      @if (isTaxRelatedCustomTranslationsEnabled !== null) {
      <div class="label">
        {{
          'myAccount.orderDetails.orderTotalSummary.subtotal'
            | cxTranslate
              : {
                  context: setCustomContext(
                    isTaxRelatedCustomTranslationsEnabled,
                    activeCountry$ | async,
                    activeLanguage$ | async
                  )
                }
        }}
      </div>
      } @if (!showSrp) {
      <div class="value">{{ order?.subTotal?.formattedValue }}</div>
      }
    </div>
    @if (!OrderDetailsHideDiscountEnabled) {
    <div class="group-info">
      <div class="label">{{ 'myAccount.orderDetails.orderTotalSummary.discount' | cxTranslate }}</div>
      @if (!showSrp) {
      <div class="value">{{ order?.orderDiscounts?.formattedValue }}</div>
      }
    </div>
    } @if (!(showActiveSnahCountry$ | async) && showDeliveryFee && order?.deliveryCost) {
    <div class="group-info">
      <div class="label">{{ 'myAccount.orderDetails.orderTotalSummary.deliveryFee' | cxTranslate }}</div>
      @if (!showSrp) {
      <div class="value">
        {{
          order?.deliveryCost?.value > 0
            ? order?.deliveryCost?.formattedValue
            : showFreeDelivery
            ? ('myAccount.orderDetails.orderTotalSummary.deliveryFeeFree' | cxTranslate)
            : order?.deliveryCost?.formattedValue
        }}
      </div>
      }
    </div>
    } @else {
    <ng-template [ngTemplateOutlet]="snahCountry"></ng-template>
    } @if (showActiveSnahCountry$ | async) {
    <div #snahCountry class="group-info">
      <div class="label">{{ 'myAccount.orderDetails.orderTotalSummary.deliveryFee' | cxTranslate }}</div>
      @if (!showSrp && order?.freeShipping) {
      <div class="value">
        {{ 'myAccount.orderDetails.orderTotalSummary.deliveryFeeFree' | cxTranslate }}
      </div>
      } @else {
      <ng-template [ngTemplateOutlet]="noFreeDelivery"></ng-template>
      } @if (!showSrp && !order?.freeShipping) {
      <div class="value" #noFreeDelivery>
        {{
          hasNoFreeDelivery(order) === 'feeInProgress'
            ? ('myAccount.orderDetails.orderTotalSummary.calculateFee' | cxTranslate)
            : order?.deliveryCost?.formattedValue
        }}
      </div>
      }
    </div>
    } @if (!features.disabledTax) {
    <div class="group-info">
      @if (isTaxRelatedCustomTranslationsEnabled !== null) {
      <div class="label">
        {{
          'myAccount.orderDetails.orderTotalSummary.tax'
            | cxTranslate
              : {
                  context: setCustomContext(
                    isTaxRelatedCustomTranslationsEnabled,
                    activeCountry$ | async,
                    activeLanguage$ | async
                  )
                }
        }}
      </div>
      } @if (!showSrp) {
      <div class="value">{{ order?.totalTax?.formattedValue }}</div>
      }
    </div>
    }
    <div [ngClass]="['group-info', 'total', activeCountry$ | async]">
      @if (isTaxRelatedCustomTranslationsEnabled !== null) {
      <div class="label">
        {{
          'myAccount.orderDetails.orderTotalSummary.total'
            | cxTranslate
              : {
                  context: setCustomContext(
                    isTaxRelatedCustomTranslationsEnabled,
                    activeCountry$ | async,
                    activeLanguage$ | async
                  )
                }
        }}
      </div>
      } @if (!showSrp) {
      <div class="value">{{ order?.totalPrice?.formattedValue }}</div>
      }
    </div>
    <div class="group-info">
      @if (features.shippingTaxTextEnabled) {
      <div class="tax-delivery-fee">
        {{ 'myAccount.orderDetails.orderTotalSummary.taxDeliveryFee' | cxTranslate }}
      </div>
      }
    </div>
  </div>
</div>
}
